import React from "react";
import { Box, Fade, Typography } from "@mui/material";
import { colors, typography } from "../../theme/tokens";
import { HeroBlobVisual } from "./HeroBlobVisual";

export const HeroSection: React.FC = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Fade in={isVisible} timeout={800}>
      <Box
        sx={{
          position: "relative",
          width: "100vw",
          // Mobile stacks image+text as normal in-flow content and should
          // just hug that content's height — forcing 100dvh here only
          // pushed the leftover space around (top-align vs. center still
          // leaves the same empty band). Desktop keeps the full-viewport
          // hero: the KV visual there is position:absolute with its own
          // top:50%, so the row needs the full 100vh to center against.
          height: { md: "15vh" },
          // height: { md: "100vh" },
          marginLeft: "calc(-50vw + 50%)",
          overflow: "hidden",
          backgroundColor: "#f8f9fa",
          display: "flex",
          alignItems: { md: "center" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "stretch", md: "center" },
            justifyContent: { xs: "center", md: "flex-start" },
            gap: { xs: "24px" },
            width: "100%",
            maxWidth: "1560px",
            maxHeight: "100%",
            mx: "auto",
            px: { xs: "24px", md: "48px", lg: "64px" },
            pt: { xs: "68px", md: "92px" },
            pb: { xs: "20px", md: "32px" },
            boxSizing: "border-box",
          }}
        >
          {/* <Box
            sx={{
              position: { xs: "static", md: "absolute" },
              zIndex: 1,
              width: { xs: "100%", md: "70%" },
              display: "flex",
              justifyContent: "flex-end",
              right: { md: "24px", lg: "32px" },
              top: { md: "50%" },
              transform: { md: "translateY(-50%)" },
            }}
          >
            <HeroBlobVisual
              src="/images/pagesimage/kv.webp"
              alt="Lamactキービジュアル"
            />
          </Box> */}
          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              flex: { md: "0 0 480px" },
              textAlign: "left",
              mt: { xs: "-72px", md: 0 },
            }}
          >
            {/* <Box
              sx={{
                display: "inline-block",
                backgroundColor: "rgba(248, 249, 250, 0.85)",
                backdropFilter: "blur(6px)",
                WebkitBackdropFilter: "blur(6px)",
                borderRadius: "16px",
                px: { xs: "20px", md: "28px" },
                py: { xs: "16px", md: "24px" },
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "1.9rem", md: typography.fontSize["3xl"] },
                  fontWeight: typography.fontWeight.extrabold,
                  letterSpacing: typography.letterSpacing.wide,
                  lineHeight: typography.lineHeight.tight,
                  color: colors.neutral[900],
                }}
              >
                困りごとも、面白いことも、一緒につくる。
              </Typography>
              <Typography
                sx={{
                  mt: "16px",
                  fontSize: typography.fontSize.base,
                  color: colors.neutral[700],
                  lineHeight: typography.lineHeight.relaxed,
                }}
              >
                少数精鋭のチームが、業務システムから遊び心のあるWebアプリまで、
                あなたにちょうどいい形でつくります。
              </Typography>
            </Box> */}
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};
